import { BasicClient } from "@/utils/httpClient";

export default class Payroll {
  client
  constructor() {
    this.client = new BasicClient()
  }

  requestSalaryAdvance (amount, plannedDate, reason) {
    const body = {
        amount: amount,
        plannedDate: plannedDate,
        observations: reason
    }
    return this.client.exec('/externalapis/sichernpeople/payroll/salary-advance', 'POST', body)
  }
  

  getSalaryAdvances (rowsPerPage, page) {
    return this.client.exec(`/externalapis/sichernpeople/payroll/salary-advance?pagination=${rowsPerPage},${page},0`, 'GET')
  }


  requestUserSalaryAdvance (amount, plannedDate, reason, user) {
    const body = {
        employeeId: user,
        amount: amount,
        plannedDate: plannedDate,
        observations: reason
    }

    return this.client.exec(`/manager/myteam/salary-advance`, 'POST', body)
  
}

    getPayrollStatus() {
      return Promise.resolve({ data: { data: { activate: false } } })
    }
  }

